import { render } from "./FacilitiesPage.vue?vue&type=template&id=47389a20&scoped=true"
import script from "./FacilitiesPage.vue?vue&type=script&lang=js"
export * from "./FacilitiesPage.vue?vue&type=script&lang=js"

import "./FacilitiesPage.vue?vue&type=style&index=0&id=47389a20&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47389a20"]])

export default __exports__